import type { ReactNode } from 'react';
import { cn } from '../_lib/utils';
import type { SanityImage } from '../types';
import { isValidRichText } from '../_lib/isValidRichText';
import { Anchor } from '../Anchor';
import { Media } from '../Media';
import { Text } from '../Text';

export type ProductCardProps = {
	copy?: ReactNode;
	className?: string;
	image?: SanityImage;
	href?: string;
	overline?: string;
	title: ReactNode;
};

export function ProductCard(props: ProductCardProps) {
	return (
		<article
			className={cn(
				'group/productCard relative bg-card-background-tertiary border border-border-secondary rounded-lg grid gap-responsive-md p-responsive-md transition-all duration-normal ease-smooth hover:bg-card-background-tertiary-hover hover:-translate-y-1 max-md:grid-cols-[7.5rem_1fr]',
				props.className,
			)}
			data-component='ProductCard'
		>
			<Media
				className={`lg:p-responsive-lg aspect-square rounded-md overflow-hidden [&_img]:transition-transform [&_img]:duration-normal [&_img]:ease-smooth [&_img]:h-full [&_img]:group-hover/productCard:scale-105`}
				image={props.image}
			/>
			<div>
				<div className={`grid gap-2 pb-responsive-xs md:text-center`}>
					{props.overline && (
						<Text as='span' className={`text-text-brand`} styleType='label-sm'>
							{props.overline}
						</Text>
					)}
					<Anchor
						className={`before:bottom-0 before:left-0 before:right-0 before:top-0 before:absolute before:content[""] before:z-10`}
						href={props.href}
					>
						<Text as='h2' styleType='heading-4xs'>
							{props.title}
						</Text>
					</Anchor>
					{isValidRichText(props.copy) && (
						<Text className={``} styleType='body-sm'>
							{props.copy}
						</Text>
					)}
				</div>
			</div>
		</article>
	);
}
